import { render, staticRenderFns } from "./GameUpdate.vue?vue&type=template&id=85621908&scoped=true&"
import script from "./GameUpdate.vue?vue&type=script&lang=js&"
export * from "./GameUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85621908",
  null
  
)

export default component.exports